import { Clickable, Col, Icon, Row, Text } from 'components';
import { useInfiniteScrollObserver } from 'core';
import { Api } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, PostPanel } from 'screens/Admin/components';
import { Filters, List } from './components';

const Posts = (_) => {
  const [owner, setOwner] = useState(null),
    [dataId, setDataId] = useState(null),
    [loading, setLoading] = useState(null),
    [limit, setLimit] = useState(0),
    posts = useSelector((state) => state.admin.posts),
    fetching = useRef(false),
    bottom = useRef(false),
    skipPosts = useRef(0),
    skipNews = useRef(0),
    dispatch = useDispatch(),
    scrollId = 'admin-posts-list',
    observerTarget = useRef(null);

  useInfiniteScrollObserver(observerTarget, getPosts, bottomTrigger);

  useEffect(() => {
    getPosts(true).then();
  }, []);

  useEffect(() => {
    if (fetching.current || loading) {
      return;
    }

    getPosts(true).then();
  }, [owner]);

  useEffect(() => {
    let index = posts?.length || 0;

    if (!index || loading) {
      return;
    }

    if (index !== limit) {
      let postIndex = 0,
        newsIndex = 0;

      posts.forEach((post) => {
        post.isPost ? postIndex++ : newsIndex++;
      });

      setLimit(postIndex + newsIndex);
      skipPosts.current = postIndex;
      skipNews.current = newsIndex;
    } else {
      bottomTrigger(true);
    }
  }, [posts]);

  function handleSelect(postId) {
    setDataId(postId);
  }

  function bottomTrigger(value) {
    bottom.current = value;
  }

  async function getPosts(isFilterChange) {
    if (isFilterChange) {
      dispatch({
        type: 'ADMIN_SET_POSTS',
        payload: []
      });
      setLoading(true);
      skipPosts.current = 0;
      skipNews.current = 0;
      setLimit(0);
      bottomTrigger(false);
    }

    if (fetching.current || bottom.current) {
      return;
    }

    fetching.current = true;

    /**
     * @property {number} length
     */
    const res = await Api.post('/admin/getPosts', {
      skipPosts: skipPosts.current,
      skipNewsViews: skipNews.current,
      ownerId: owner?._id
    });

    fetching.current = false;
    setLoading(false);

    if (!res || res.length === 0) {
      bottomTrigger(true);
      return;
    }

    bottomTrigger(false);

    dispatch({
      type: 'ADMIN_ADD_POSTS',
      payload: res
    });
  }

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center>
          <Text h3>Posts</Text>

          <Clickable
            onClick={() => {
              setDataId(true);
            }}
          >
            <Icon marg="0 0 0 8px" type="add" dimensions={18} />
          </Clickable>
        </Row>
      </Header>

      <Col start noFlex marg="54px 0 0" wid="100%" ht="100vh" id={scrollId} scrollY>
        <Filters owner={owner} setOwner={setOwner} className="filters" />

        <List data={posts} dataId={dataId} onClick={handleSelect} loading={loading} />
        <div ref={observerTarget}></div>
      </Col>

      <PostPanel dataId={dataId} setDataId={handleSelect} closeModal={() => setDataId(null)} />
    </Col>
  );
};

export default Posts;
